import React from 'react';
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';
import BranchMultiSelectAutoCompleteInput from 'screens/components/basic/BranchMultiSelectAutoCompleteInput';

const componentName = "ManualInventoryChange";

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="col-xs-6 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.beginDate.name}
                    floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                    hintText={LOOKUP.report.common.beginDate.label + "*"}
                    fullWidth={true}
                    required
                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.endDate.name}
                    floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                    hintText={LOOKUP.report.common.endDate.label + "*"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                <BranchMultiSelectAutoCompleteInput
                    defaultValues={props.branchOptions}
                    name={`${componentName}BranchIds`}
                    label="Branches"
                    floatingLabelText="Branches"
                    hintText="Select Branches"
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                <SelectInput
                    defaultValue={"0"}
                    name={componentName + `FilterAction`}
                    fullWidth={true}
                    label={"Action" + "*"}
                    floatingLabelText={"Action" + "*"}
                    hintText={"Action" + "*"}
                    options={props.actionOptions}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                <SelectInput
                    defaultValue={"0"}
                    name={componentName + `FilterReason`}
                    fullWidth={true}
                    label={"Reason" + "*"}
                    floatingLabelText={"Reason" + "*"}
                    hintText={"Reason" + "*"}
                    options={props.reasonOptions}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-3">
                <SelectInput
                    defaultValue={"2"}
                    name={componentName + "IsCannabis"}
                    fullWidth={true}
                    label={"Type"}
                    floatingLabelText={"Type"}
                    hintText={"Type"}
                    options={props.isCannabisOptions && props.isCannabisOptions.length > 0 ? props.isCannabisOptions : []}
                />
            </div>  {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-4 col-lg-2 col-xl-4 m-0">
                <SelectInput
                    name={componentName + LOOKUP.report.common.categoryName}
                    fullWidth={true}
                    label={LOOKUP.report.common.subcategory}
                    floatingLabelText={LOOKUP.report.common.subcategory}
                    hintText={LOOKUP.report.common.subcategory}
                    options={props.productCategories && props.productCategories.length > 0 ? (props.isCannabis == 0 ? props.productCategories.filter(x => !x.isCannabis) : (props.isCannabis == 1 ? props.productCategories.filter(x => x.isCannabis) : props.productCategories)) : []}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={props.download}
                />
            </div>
        </div>
    </CardSimple>
);

export default Header;
